import { EmailSendingDomain } from '@/models/emailSendingDomains';
import { PrepareConnectorFlowStepResponse } from '@/services/endpoints/workspace-connectors';
import { extractDomainDetailFromStep2, extractFlowParamsFromStep2 } from './domainInfoFlowMapper';

type PrepareStepResult = PrepareConnectorFlowStepResponse['configuration'] extends infer T
  ? T extends { elements?: { params?: infer Params } }
    ? NonNullable<Params>
    : Record<string, unknown>
  : Record<string, unknown>;

export type DomainInfoStep2Result = {
  domain: EmailSendingDomain;
  flowParams: Record<string, unknown>;
};

export const mapDomainInfoStep2Response = (response: PrepareConnectorFlowStepResponse, domainId: string, domainName?: string): DomainInfoStep2Result => {
  const step2Params = response?.configuration?.elements?.params as PrepareStepResult;
  const flowParams = extractFlowParamsFromStep2(step2Params);

  return {
    domain: extractDomainDetailFromStep2(step2Params, domainId, domainName),
    flowParams,
  };
};
